// 03 — tell us what works. The core of the page: one state at a time
// (expired notice → email → code → form → done), driven by the view model.
import type { ReunionApi } from '../state/useReunion';
import { Section } from './primitives';
import { CodeStep } from './respond/CodeStep';
import { DoneStep } from './respond/DoneStep';
import { EmailStep } from './respond/EmailStep';
import { ResponseForm } from './respond/ResponseForm';

export function SectionRespond({ api }: { api: ReunionApi }) {
  const { view, state, actions } = api;
  if (!view) return null;
  const { content } = view;

  return (
    <Section label="03 respond" id="respond" style={{ scrollMarginTop: 80 }}>
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 12,
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
          color: 'var(--orange)',
        }}
      >
        03 — tell us what works
      </div>
      <h2
        style={{
          fontSize: 'clamp(32px,8vw,42px)',
          fontWeight: 900,
          letterSpacing: '-0.04em',
          lineHeight: 1,
          margin: '16px 0 10px',
        }}
      >
        this is the part that matters
      </h2>
      <p style={{ fontSize: 19, lineHeight: 1.55, color: 'var(--cyan-soft)', margin: '0 0 26px', textWrap: 'pretty' }}>
        four questions. one of them only I see.
      </p>

      {view.expired && (
        <div
          style={{
            background: 'rgba(255,59,31,0.14)',
            border: '1px solid var(--orange)',
            borderRadius: 12,
            padding: '16px 18px',
            marginBottom: 18,
          }}
        >
          <div style={{ fontSize: 19, fontWeight: 700 }}>you've been signed out</div>
          <div style={{ fontSize: 17, color: 'var(--body-2)', marginTop: 4 }}>
            it's been six months. same drill — email, code, done.
          </div>
        </div>
      )}

      {view.stepEmail && (
        <EmailStep
          email={state.email}
          onEmail={actions.onEmail}
          onSend={actions.sendCode}
          busy={state.busy}
          notListed={view.notListed}
        />
      )}

      {view.stepCode && (
        <CodeStep
          email={state.email}
          code={state.code}
          onCode={actions.onCode}
          onVerify={actions.verify}
          onResend={actions.resend}
          onBackToEmail={actions.backToEmail}
          busy={state.busy}
          codeErr={view.codeErr}
        />
      )}

      {view.stepForm && (
        <ResponseForm
          householdLabel={view.householdLabel}
          form={state.form}
          setForm={actions.setForm}
          weeks={content.weeks}
          window={view.window}
          travelModes={content.travelModes}
          onSubmit={actions.submit}
          busy={state.busy}
        />
      )}

      {view.stepDone && <DoneStep onEditAgain={actions.editAgain} />}
    </Section>
  );
}
